import { graphQLRequest } from "../api/utils";
import { put, select, call } from "redux-saga/effects";
import { auth } from "../api/auth";
import { receivedApiToken, logout } from "../actions/login.actions";
import { List } from "immutable";
import { doCheckLoginToken } from "./login.saga";
import firebase from "firebase";

function hasErrors(results) {
    return !results || (results.errors && results.errors.length > 0);
}

export function* doGraphQLQuery(query, retryOnAuth = true) {
    let results;
    try {
        const token = yield select(({ userSettings: { apiToken } }) => {
            return apiToken;
        });
        results = yield call(graphQLRequest, query, token);
    } catch (e) {
        // On 401, try to refresh the API token with the idToken.
        // If successful, retry the request.  Otherwise,
        // throw an exception (and logout if the error is an auth error).
        if (e.statusCode === 401 && retryOnAuth) {
            let oldIdToken = yield select(({ userSettings: { idToken } }) => {
                return idToken;
            });

            let idToken;
            if (oldIdToken) {
                try {
                    idToken = yield firebase
                        .auth()
                        .currentUser.getIdToken(true);
                } catch (e) {
                    yield put(logout());
                }
            }

            if (idToken) {
                try {
                    const response = yield call(auth, idToken);
                    yield put(receivedApiToken(response));
                    yield call(doCheckLoginToken);
                } catch (authError) {
                    if (
                        authError.statusCode === 403 ||
                        authError.statusCode >= 500
                    ) {
                        yield put(logout());
                    }
                    throw authError;
                }
                return yield call(doGraphQLQuery, query, false);
            }
        }

        // If it's not a 401 error, then rethrow the error
        throw e;
    }

    // If the results have an error, then only return the errors.
    if (hasErrors(results)) {
        const error = new Error("Something went wrong with the graphql query.");
        error.gqlErrors = results && results.errors;
        throw error;
    }
    return results.data;
}

// TODO: handle errors correctly.
export function* handleFailure(e, failureAction) {
    let errors;
    if (e.gqlErrors) {
        errors = List(e.gqlErrors);
    } else if (e.status) {
        errors = List.of(e.status);
    } else {
        errors = List.of(e.toString());
    }
    yield put(failureAction({ errors }));
}



// WEBPACK FOOTER //
// ./src/sagas/graphql.saga.js